import { render, staticRenderFns } from "./StockNewsPanel.vue?vue&type=template&id=433ba0b5&scoped=true&"
import script from "./StockNewsPanel.vue?vue&type=script&lang=js&"
export * from "./StockNewsPanel.vue?vue&type=script&lang=js&"
import style0 from "./StockNewsPanel.vue?vue&type=style&index=0&id=433ba0b5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433ba0b5",
  null
  
)

export default component.exports